import styled from 'styled-components'
import {COLOR} from 'src/service/constant/color'
import {customMedia} from "src/styles/common/common";

export const ModalWrap = styled.div<{ toggle: any, zIndex: number, width?: string }>`
  z-index: ${(props) => (props.zIndex)};
  width: ${(props) => props.width || '100%'};
  height: 100vh; 
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  display: ${(props) => (props.toggle ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
`



export const ModalBox = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: block;
  background: white;
  width: 400px;
  height: auto;
  box-shadow: 0 2px 5px rgba(42, 41, 46, 0.16);
  border-radius: 16px;
  text-align: center;
  ${customMedia.lessThan('modal')`
     min-width: 328px;
     width: 92.5%;
  `}
  ${customMedia.lessThan('tablet_cut_line')`
     max-width: 328px;
     width: 100%;
     margin: 0 auto;
  `}
  > h4 {
    margin: 0;
    font-weight: 700;
    font-size: 16px;
    color: black;
  }

  > p {
    margin: 20px 0;
  }

  > img {
    z-index: 1;
    max-width: 280px;

    margin-left: -20px;
  }
`
export const ModalOnlyTitle = styled.h4`
  margin: 40px 0 28px 0;
  font-family: NotoSansBold, sans-serif;
  min-height: 80px;
  height: auto;
  white-space: pre-line;
  font-size: 18px;
  display: flex;
  word-break: keep-all;
  justify-content: center;
  align-items: center;
`
export const ModalTermsContents = styled.div<{isContentTypeText: boolean}>`
  font-size: 12px;
  font-family: NotoSansRegular, sans-serif;
  max-width: 368px;
  width: 100%;
  height: 240px;
  overflow: scroll;
  background-color: ${COLOR.gray10};
  margin: 0 auto;
  padding: 16px;
  white-space: ${(props) => props.isContentTypeText ? 'pre-wrap' : 'normal'};
  text-align: left;
  border-radius: 10px;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  > p {
    margin: 0;
    line-height: 1.5;
  }
  
  ::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
`
export const ModalTimeOfBirth = styled.div`
  margin: 16px;
  display: flex;
  height: 325px;
  overflow: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  ::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }

  > div {
    display: block;
  }
`

export const ModalDayOfBirth = styled.div`
  display: flex;
  border: 1px solid red;
  margin-top: 16px;
`

export const ModalDefaultTitle = styled.h4`
  margin: 28px 0 16px 0;
  font-family: NotoSansBold, sans-serif;
  font-size: 18px;
  display: inline-block;
  max-width: 368px;
  width: 100%;
  white-space: pre-wrap;
  justify-content: center;
  align-items: center;

  &.time_of_birth {
    margin: 8px 0 0 0;
  }

  &.day_of_birth {
    margin: 23px 0 0 0;
  }
`

export const ModalAlertContent = styled.div`
  min-height: 256px;
  padding: 16px;
`

export const ModalConfirmContent = styled.div`
  display: block;
  text-align: center;
  padding: 16px;

  > section {
    width: 280px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    > div {
      margin: 0 0 28px 0;
    }
  }
`

export const NoticeWrap = styled.div`
  display: block;
  white-space: normal;

  > p {
    margin: 16px 0;
    color: ${COLOR.red};
    font-size: 14px;
    line-height: 20px;
  }
`
export const NoticeContent = styled.div`
  border-radius: 10px;
  background: ${COLOR.gray80};
  margin-bottom: 16px;
  padding: 16px;
  font-size: 12px;
  text-align: left;

  > section {
    width: 100%;
    height: 96px;
    background: ${COLOR.white};
  }
`

export const ModalRefundWrap = styled.div`
  min-height: 300px;
  padding: 16px 16px 2px 16px;
  border-radius: 20px;
  
 ${customMedia.lessThan('mobile')`
  padding: 10px 16px 0px 16px;
 `}
`


export const ModalRefundTitle = styled.h4`
  display: inline-block;
  margin: 14px 0 0 0;
  
  font-family: NotoSansBold, sans-serif;
  font-size: 18px;
  align-items: center;
`
export const ModalRefundContents = styled.div`

  margin: 24px 0px;
  padding: 19px 15px;

  font-size: 14px;
  font-family: NotoSansRegular, sans-serif;
  background-color: ${COLOR.gray10};

  align-items: center;
  white-space: pre-wrap;
  overflow: scroll;

  
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  ::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }

  ${customMedia.lessThan('tablet')`
    
 `}
 ${customMedia.lessThan('mobile')`
    margin: 16px 0px;
    padding: 13px 16px;
    
    font-size: 12px;
 `}
`
